import map from 'lodash/map';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import flatten from './flatten';

/**
 * Parse query strings but only in their simplest form.
 *
 * @param {string} search
 * @returns {object} Object mapping key to value.
 * @example
 * parse('?a=1&b=2&c=3') // { a: 1, b: 2, c: 3 }
 */
export const parse = (search) => {
  if (!search) {
    return {};
  }
  if (search.charAt(0) === '?') {
    return parse(search.substr(1));
  }
  const parts = search.split('&');
  const query = {};
  parts.forEach((part) => {
    const [key, value] = part.split('=');
    if (value !== undefined) {
      query[decodeURIComponent(key)] = decodeURIComponent(value);
    }
  });
  // TODO: Implement schema un-flatten. The schema will be useful
  //       to figure out whether value should be an array or object.
  return query;
};

/**
 * Encode query object in a form of querystring.
 *
 * @param {string} query
 * @returns {string} encoded querystring
 * @example
 * encode({ a: 1, b: 2, c: 3 }) // '?a=1&b=2&c=3'
 */
export const encode = (query) => {
  if (!query) {
    return '';
  }
  const flatQuery = flatten(query, (key, props) =>
    props.isRoot ? key : `[${key}]`,
  );
  const parts = map(
    omitBy(flatQuery, isNil),
    (value, key) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
  );
  if (parts.length === 0) {
    return '';
  }
  return `?${parts.join('&')}`;
};
